import { zodResolver } from "@hookform/resolvers/zod";
import type { Resolver } from "react-hook-form";
import type { z } from "zod";

/**
 * Adapts a Zod schema to react-hook-form.
 *
 * Zod's input type (before `.default()` / `.transform()`) differs from its output type. RHF 7 +
 * `@hookform/resolvers` 5 types the resolver as `Resolver<Input, …, Output>`, while `useForm<Output>`
 * expects `Resolver<Output>`. The runtime behaviour is correct; this narrows the types without `any`.
 */
export function rhfResolver<T extends z.ZodType>(schema: T): Resolver<z.output<T>> {
  return zodResolver(schema) as unknown as Resolver<z.output<T>>;
}
